import { useEffect } from "react";
import { Phone, Mail } from "lucide-react";
import SiteHeader from "@/components/suffa/SiteHeader";
import SiteFooter from "@/components/suffa/SiteFooter";
import { OrnamentDivider } from "@/components/suffa/Ornaments";
import { useLanguage } from "@/lib/i18n";
import "@/pages/Contact.css";

const Contact = () => {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = "Contact Us | Suffa Matrimony";
  }, []);

  return (
    <div className="suffa-page">
      <SiteHeader />
      <main className="contact-main">
        <section className="contact-masthead">
          <div className="contact-container contact-masthead-inner">
            <OrnamentDivider />
            <h1 className="contact-title" data-testid="contact-title">
              {t("Contact Us")}
            </h1>
            <p className="contact-subtitle" data-testid="contact-subtitle">
              {t("Our team is happy to guide you through your search for a blessed partnership.")}
            </p>
          </div>
        </section>

        <section className="contact-container contact-cards" data-testid="contact-cards">
          <a href="tel:9924610588" className="contact-card" data-testid="contact-call-link">
            <span className="contact-icon" aria-hidden="true">
              <Phone size={20} />
            </span>
            <span className="contact-label">{t("Call Us")}</span>
            <span className="contact-value" data-testid="contact-phone-value">
              9924610588
            </span>
            <span className="contact-hint">{t("Tap to call our team")}</span>
          </a>

          <a href="mailto:suffamatrimony@gmail.com" className="contact-card" data-testid="contact-email-link">
            <span className="contact-icon" aria-hidden="true">
              <Mail size={20} />
            </span>
            <span className="contact-label">{t("Email Us")}</span>
            <span className="contact-value" data-testid="contact-email-value">
              suffamatrimony@gmail.com
            </span>
            <span className="contact-hint">{t("Tap to write to us")}</span>
          </a>
        </section>

        <div className="contact-footer-space" />
      </main>
      <SiteFooter />
    </div>
  );
};

export default Contact;
